export default __webpack_public_path__ + "static/media/Elektra.f3603434.png";